'use client';

import { useState } from 'react';
import { useSearchBox } from 'react-instantsearch';

interface SearchBannerNewProps {
  dict: any;
}

export default function SearchBannerNew({ dict }: SearchBannerNewProps) {
  const { query, refine } = useSearchBox();
  const [searchQuery, setSearchQuery] = useState(query);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    refine(value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    refine(searchQuery);
  };

  return (
    <section className="community-banner calendar-banner">
      <div
        className="banner-box"
        style={{
          backgroundImage: 'url(/images/banner/community_banner.png)',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-lg-6">
              <div className="main-content">
                <h1>Community Calendar</h1>
                <div className="share-links">
                  {[
                    'email_icon.svg',
                    'printer_icon.svg',
                    'pdf_icon.svg',
                    'fb_white_icon.svg',
                    'linkedin_white_icon.svg',
                    'vimeo_icon.svg',
                  ].map((icon, i) => (
                    <span key={i}>
                      <a href="#" target="_blank" rel="noreferrer">
                        <img src={`/images/icons/${icon}`} alt="" />
                      </a>
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Desktop Search Form */}
            <div className="col-lg-5 d-none d-xl-block d-lg-block">
              <div className="find-box">
                <form onSubmit={handleSubmit}>
                  <div className="sip-box">
                    <label>
                      <img src="/images/icons/keyword_search.svg" alt="" />
                    </label>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search by keyword or name"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>

                  <div className="sip-box">
                    <label>
                      <img src="/images/icons/region.svg" alt="" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter City"
                    />
                  </div>

                  <button type="submit" className="btn btn-secondary">
                    Search
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Search Form */}
      <div className="container">
        <div className="row">
            <div className="col-lg-12 d-lg-none d-md-block">
              <div className="find-box">
                <form onSubmit={handleSubmit}>
                  <div className="sip-box">
                    <label>
                      <img src="/images/icons/keyword_search.svg" alt="" />
                    </label>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search by keyword or name"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>

                  <div className="sip-box">
                    <label>
                      <img src="/images/icons/region.svg" alt="" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter City"
                    />
                  </div>

                  <button type="submit" className="btn btn-secondary">
                    Search
                  </button>
                </form>
              </div>
            </div>
        </div>
      </div>
    </section>
  );
}
